import { useState, useEffect } from "react";

// Diwali 2026 — offer ends 8 Nov 2026, 11:59 PM IST
const OFFER_END = new Date("2026-11-08T23:59:59+05:30").getTime();

function useCountdown() {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const diff = Math.max(0, OFFER_END - now);
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000) / 60000),
    seconds: Math.floor((diff % 60000) / 1000),
    expired: diff === 0,
  };
}

const pad = (n) => String(n).padStart(2, "0");

export function CountdownInline({ className = "" }) {
  const { days, hours, minutes, seconds, expired } = useCountdown();
  if (expired) return <span className={className}>Offer ending soon</span>;
  return (
    <span className={`font-mono font-bold tabular-nums ${className}`} data-testid="offer-countdown">
      Ends in {days}d {pad(hours)}h {pad(minutes)}m {pad(seconds)}s
    </span>
  );
}

export function CountdownBoxes({ dark = false }) {
  const { days, hours, minutes, seconds, expired } = useCountdown();
  if (expired) return <p className={`text-sm font-semibold ${dark ? "text-white" : "text-slate-900"}`}>Offer ending soon — claim now!</p>;
  const units = [
    [days, "Days"],
    [hours, "Hrs"],
    [minutes, "Min"],
    [seconds, "Sec"],
  ];
  return (
    <div className="flex gap-2" data-testid="offer-countdown-boxes">
      {units.map(([val, label]) => (
        <div key={label} className={`flex-1 rounded-xl py-2.5 text-center ${dark ? "bg-white/10 border border-white/15" : "bg-slate-100"}`}>
          <p className={`font-display text-xl font-bold tabular-nums ${dark ? "text-white" : "text-slate-900"}`}>{pad(val)}</p>
          <p className={`text-[10px] font-bold uppercase tracking-wider ${dark ? "text-white/60" : "text-muted-foreground"}`}>{label}</p>
        </div>
      ))}
    </div>
  );
}
